export default "__VITE_ASSET__373c67b8__"